// import LandCover from "../assets/Landcover.json";

// export const landCover = LandCover.features.map((x: any) => ({
//   coordinates: x.geometry.coordinates,
//   name: x.properties.Name,
//   type: x.properties.LEVEL2,
// }));

export const landCover = ''
